export function validateOwner(record) {
    const missingFields = [];
    if (!String(record.origin_owner_id || "").trim()) missingFields.push("Key");
    if (!String(record.owner_name || "").trim()) missingFields.push("Name");
    if (missingFields.length) {
        return [false, `Please enter ${missingFields.join(" and ")} before saving.`];
    }

    if ((!record.owner_id || record.owner_id === "new") && /["'\s]/.test(record.origin_owner_id)) {
        return [false, "ALERT!: Key values cannot include space or quote characters. Please edit the Key value to remove any space or quote characters."];
    }

    const emailRegex = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
    if ((record.email && !emailRegex.test(record.email)) || (record.contact_email && !emailRegex.test(record.contact_email))) {
        return [false, "The email is not a correct format"];
    }

    const urlRegex = /^[\w.-]{3}(?:\.[\w.-]+)+[\w\-._~:/?#[\]@!$&'()*+,;=.]+$/;
    const website = record.website ?? record.internet;
    if (website && !urlRegex.test(website)) {
        return [false, "The url (website) is not a correct format. Please enter www.{}.{}"];
    }

    return [true, ""];
}